export const getters = {
  tripIncomerows: state => state.trip_income,
  systemTrips: state => state.trips,
  Trip: state => state.systemTrip
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/trips/getters.js